import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface UpdateOwnerShareRelianceAccessPayload {
  ownerUuid: string;
  shareId: number;
  isHistoryAccepted: boolean;
}

export const useUpdateOwnerShareRelianceAccess = (
  options?: UseMutationOptions<
    any,
    Error,
    UpdateOwnerShareRelianceAccessPayload
  >
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateOwnerShareRelianceAccess"],
    mutationFn: async ({
      ownerUuid,
      shareId,
      isHistoryAccepted,
    }: UpdateOwnerShareRelianceAccessPayload) => {
      return axiosInstance
        .patch(`/successors/${ownerUuid}/shares/${shareId}/reliance-access`, {
          isHistoryAccepted,
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa zapisywanie zmian...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "update-reliance-access",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Zmiany zostały zapisane.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "update-reliance-access",
      });
      queryClient.invalidateQueries({
        queryKey: ["investments/grouped", "successor", variables.ownerUuid],
      });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas aktualizacji dostępu.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "update-reliance-access",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
